import { render, staticRenderFns } from "./TwoForOneCampaign.vue?vue&type=template&id=051a952f&"
import script from "./TwoForOneCampaign.vue?vue&type=script&lang=js&"
export * from "./TwoForOneCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports